import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import AccordionContainer from '../../containers/accordion-container';
import AccordionItem from '../../blocks/accordion-item';

const AccordionContainerBlock = props => <AccordionContainer {...props} />;
AccordionContainerBlock.displayName = 'AccordionContainer';

export default withDynamicComponents({
  componentWhitelist: [
    AccordionItem
  ],
  mapInputToOutput: [
    
  ],
})(AccordionContainerBlock);



// WEBPACK FOOTER //
// ./src/blocks/accordion-container/index.jsx